import { Routes } from '@angular/router';
import { sessionGuard } from './auth/guards/session-guard';
import { platformInitGuard } from '@core/guards/platform-init.guard';
import { Auth } from '@auth/routes/auth-shell';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./landing/landing.routes'),
  },
  {
    path: 'cardapio/:slug',
    title: 'Cardápio',
    loadComponent: () => import('./public-menu/public-menu'),
  },
  {
    path: 'auth',
    component: Auth,
    canMatch: [sessionGuard],
    loadChildren: () => import('./auth/routes/auth.routes'),
  },
  {
    path: 'app',
    loadChildren: () => import('./platform/platform.routes'),
    canMatch: [sessionGuard, platformInitGuard],
  },
  {
    path: '**',
    redirectTo: '',
  },
];
